/* eslint-disable sciencepo-rules/require-story*/
/* Inutile de le tester*/
import React, {Fragment} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import ActionElementList from '../shared/related_contents/ActionElementList';
import AppButton from '../shared/AppButton';
import EventInfo from '../shared/related_contents/EventInfo';
import IconContainer from '../shared/IconContainer';
import KeyFigureList from '../shared/related_contents/KeyFigureList';
import Thumbnail from '../shared/related_contents/Thumbnail';
import * as pageStyles from '../../styles/internal-page/internal-page.module.scss';
import ProductInfos from '../shared/related_contents/ProductInfos';

const RelatedContent = ({elem}) => {
  if (elem.__typename === 'CmsPortalComponentWidgetRelatedContentGroup') {
    if (elem.related_contents?.length > 0) {
      return elem.related_contents.map((elem, index) => {
        if (elem?.content?.length > 0) {
          return elem.content.map((elem, subIndex) => {
            return (
              <div className={pageStyles.relatedContentContainer}
                key={subIndex}
              >
                <RelatedContent
                  elem={elem}
                  subIndex={subIndex}
                />
              </div>
            );
          });
        }
        return <Fragment key={index}/>;
      });
    }
  }

  if (elem.__typename === 'CmsPortalComponentWidgetActionElement') {
    return (
      <div
        className={pageStyles.marginBetweenBlocs}
        key={elem.__typename}
      >
        <AppButton
          color={elem.actionColor === 'BLACK' ? 'primary' : 'secondary'}
          isActionElement
          minContent
          onClick={() => typeof window !== 'undefined' && window.open(elem.URL, '_blank')}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              typeof window !== 'undefined' && window.open(elem.URL, '_blank');
            }
          }}
          padding={12}
          paddingSide={7}
          rightIcon={
            <IconContainer color="WHITE"
              icon={elem.icon}
              noHover
              size={25}
              svgClassname={pageStyles.actionElementSVG}
            />
          }
          tabIndex="0"
          variant="contained"
          width={'100%'}
        >
          <p
            className={clsx(pageStyles.h4Label, pageStyles.noUpperCase, pageStyles.relatedTitleBig)}
          >
            {elem.label}
          </p>
        </AppButton>
      </div>);
  }
  if (elem.__typename === 'CmsPortalComponentWidgetThumbnail') {
    return (
      <div
        className={pageStyles.marginBetweenBlocs}
      >
        <Thumbnail
          color={elem.thumbnailColor}
          html={elem.content}
          title={elem.title}
        >
        </Thumbnail>
      </div>
    );
  }
  if (elem.__typename === 'CmsPortalComponentWidgetActionElementList') {
    return (
      <div
        className={pageStyles.marginBetweenBlocs}
      >
        <ActionElementList
          actions={elem.action}
          color={elem.actionListColor}
          title={elem.title}
        >
        </ActionElementList>
      </div>
    );
  }

  if (elem.__typename === 'CmsPortalComponentWidgetKeyFigureList') {
    return (
      <div
        className={pageStyles.marginBetweenBlocs}
      >
        <KeyFigureList
          color={elem.keyFigureColor}
          figures={elem.figures}
          title={elem.title}
        >
        </KeyFigureList>
      </div>
    );
  }

  if (elem.__typename === 'CmsPortalComponentWidgetEventInfo') {
    return (
      <div
        className={pageStyles.marginBetweenBlocs}
      >
        <EventInfo
          color={elem.eventColor}
          event={elem.event}
          title={elem.title}
        >
        </EventInfo>
      </div>
    );
  }

  if (elem.__typename === 'CmsPortalComponentWidgetProductInfo') {
    return (
      <div
        className={pageStyles.marginBetweenBlocs}
      >
        <ProductInfos
          relatedContent={elem}
        />
      </div>
    );
  }

  return null;
};

RelatedContent.propTypes = {
  elem: PropTypes.shape({
    __typename: PropTypes.string.isRequired,
    related_contents: PropTypes.arrayOf(
      PropTypes.shape({
        content: PropTypes.arrayOf(
          PropTypes.object.isRequired
        ).isRequired,
      })
    ),
    URL: PropTypes.string,
    actionColor: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string,
    thumbnailColor: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
    actionListColor: PropTypes.string,
    action: PropTypes.arrayOf(
      PropTypes.object
    ),
    keyFigureColor: PropTypes.string,
    figures: PropTypes.arrayOf(
      PropTypes.object
    ),
    eventColor: PropTypes.string,
    event: PropTypes.object,
  }).isRequired,
  subIndex: PropTypes.number,
};

export default RelatedContent;
